export default __webpack_public_path__ + "static/media/vid-08.cc235fd7.mp4";